import { Fragment, memo } from "react";
import PropTypes from "prop-types";
import "./FooterLogos.scss";
import { FooterAtoutFranceLogoIcon, FooterSetoLogoIcon } from "app/icons/logo";

const FooterLogos = ({ shop = "" }) => {
	const locale = shop.slice(3, 5);

	switch (locale) {
		case "FR": {
			return (
				<Fragment>
					<div className="footer-logos">
						<div className="footer-logos__item">
							<FooterAtoutFranceLogoIcon width={45} height={45} />
						</div>
						<div className="footer-logos__item">
							<FooterSetoLogoIcon width={45} height={45} />
						</div>
					</div>
				</Fragment>
			);
		}
		case "GB": {
			return <div className="footer-logos" />;
		}
		default:
			return false;
	}
};

FooterLogos.propTypes = {
	shop: PropTypes.string.isRequired,
};

export default memo(FooterLogos);
